export default "/latin.20fc9b6f-9bff68.woff2";